var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 29.8332H12.0007C5.33398 29.8332 2.66732 27.1665 2.66732 20.4998V12.4998C2.66732 5.83317 5.33398 3.1665 12.0007 3.1665H20.0007C26.6673 3.1665 29.334 5.83317 29.334 12.4998V20.4998C29.334 27.1665 26.6673 29.8332 20.0007 29.8332Z",
    fill: "#ECF3FE",
    stroke: "#3F87F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17284 17.0737L9.78617 16.3537C13.1862 12.3804 17.7462 9.56706 22.8262 8.3004",
    fill: "#ECF3FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17284 17.0737L9.78617 16.3537C13.1862 12.3804 17.7462 9.56706 22.8262 8.3004",
    stroke: "#3F87F4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0781 17.0737H9.17146V13.1804",
    fill: "#ECF3FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0781 17.0737H9.17146V13.1804",
    stroke: "#3F87F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17284 17.0737L9.78617 16.3537C13.1862 12.3804 17.7462 9.56706 22.8262 8.3004",
    fill: "#ECF3FE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17284 17.0737L9.78617 16.3537C13.1862 12.3804 17.7462 9.56706 22.8262 8.3004",
    stroke: "#3F87F4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8262 24.7933V16.5",
    stroke: "#3F87F4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24.6865V19.1665",
    stroke: "#3F87F4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17383 24.5935V21.8335",
    stroke: "#3F87F4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusUp);
export default __webpack_public_path__ + "static/media/status-up.925d7a78f8a62b745102c7dedd621224.svg";
export { ForwardRef as ReactComponent };